// A check box as a drawing: a square, with a tick when it is on. A button
// that is a switch has it before its words. It takes no click of its own.

import { svg } from '../lib/svg';

const BOX = 16;
const EDGE = 'M2 2 H14 V14 H2 Z';
const TICK = 'M4.5 8.5 L7 11 L11.5 5';

export const createCheckBox = (checked: boolean): SVGSVGElement =>
  svg(
    'svg',
    { class: 'check-box', viewBox: `0 0 ${BOX} ${BOX}`, 'aria-hidden': 'true' },
    checked ? [svg('path', { d: EDGE }), svg('path', { d: TICK })] : [svg('path', { d: EDGE })],
  );
